import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-box',
  templateUrl: './confirmation-box.component.html',
  styleUrls: ['./confirmation-box.component.scss']
})
export class ConfirmationBoxComponent {

  constructor(
    public dialogRef: MatDialogRef<ConfirmationBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { message?: string, title?: string, button1?: string, button2?: string, IsRemoveAction?: boolean }
  ) {}

  onCloseClick(): void {
    this.dialogRef.close({ confirmed: false });
  }
  onConfirmDeleteClick(): void {
    this.dialogRef.close({ confirmed: true });
  }
  onPermanentDeleteClick(): void {
    this.dialogRef.close({ confirmed: true, isPermanent: true });
  }
}
